<div *ngIf="dialogs$ | async as dialog" class="dialog-overlay">
  <div class="dialog">
    <h4 class="dialog-header branding-accent-normal-background">
      {{dialog.title | translate}}
    </h4>

    <div class="dialog-body">
      <div *ngFor="let message of dialog.messages" class="dialog-message">
        {{hasParams(message) ? (message.value | translate:message.params) : (message | translate)}}
      </div>
    </div>

    <div class="dialog-footer">
      <cp-button *ngFor="let action of dialog.actions" class="dialog-action"
                 [label]="action.name" (click)="execute(action)" [secondary]="action.secondary">
      </cp-button>
    </div>
  </div>
</div>
